import { store } from '@/store/index.js'
import app from '../main'

function slugify (resource, type, action, language = null) {
  if (action === 'create') {
    if (language) {
      resource.languages[language].url = slugifyString(resource.languages[language].title)
    } else {
      resource.url = slugifyString(resource.title)
    }
  } else {
    if (language) {
      store.dispatch(type, {url: slugifyString(resource.languages[language].title), language: language})
    } else {
      store.dispatch(type, slugifyString(resource.title))
    }
  }
}

function slugifyString (value) {
  return value.toString().toLowerCase()
    .replace(/ć/g, 'c')
    .replace(/č/g, 'c')
    .replace(/ž/g, 'z')
    .replace(/š/g, 's')
    .replace(/đ/g, 'd')
    .split(/\\&+/).join('-and-')
    .split(/[^a-z0-9]/).join('-')
    .split(/-+/).join('-')
    .trim('-')
}

function submitResource (validator, Resource, params, action) {
  validator.validateAll().then(result => {
    if (result) {
      if (action === 'create') {
        Resource.create(params)
      } else if (action === 'edit') {
        Resource.update(params)
      }
      return
    }
    app.$snotify.warning('Please fix all validation errors', '')
  })
}

function objectToFormData (obj, form, namespace) {
  var fd = form || new FormData()
  var formKey

  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (namespace) {
        formKey = namespace + '[' + property + ']'
      } else {
        formKey = property
      }

      // if the property is an object, but not a File,
      // use recursivity.
      if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
        objectToFormData(obj[property], fd, property)
      } else {
        // if it's a string or a File object
        if (obj[property] !== null) {
          fd.append(formKey, obj[property])
        }
      }
    }
  }

  return fd
};

export {slugify, slugifyString, submitResource, objectToFormData}



// WEBPACK FOOTER //
// ./src/helpers/handleForm.js